export default {"src":"/_next/static/media/mock_bookmark_empty.817a2e10.svg","height":17,"width":13,"blurWidth":0,"blurHeight":0};